// extracted by mini-css-extract-plugin
export default {"modal":"UserOnboardingPage_modal__JDuNO"};